/* CCS Chemicals - Theme JavaScript */
document.addEventListener('DOMContentLoaded', function () {

  // ============================================
  // B2B STOCK INDICATOR (shared helper)
  // Coloured dot + count. Only active for customers tagged 'b2b' — the <body>
  // carries .ccs-b2b-tag (set server-side in theme.liquid), and the per-variant
  // stock maps are rendered in Liquid only for those customers, so retail
  // shoppers never see stock and the numbers aren't in their page source.
  // Levels mirror snippets/stock-badge.liquid (LOW = 5).
  // ============================================
  window.CCSStock = (function () {
    var LOW = 5;
    function enabled() { return document.body.classList.contains('ccs-b2b-tag'); }
    // q: quantity, tracked: inventory managed, cont: policy allows overselling.
    function compute(q, tracked, cont) {
      q = parseInt(q, 10) || 0;
      if (!tracked) return { level: 'in', label: 'In stock' };
      if (q > LOW) return { level: 'in', label: q + ' in stock' };
      if (q > 0) return { level: 'low', label: 'Only ' + q + ' left' };
      if (cont) return { level: 'low', label: 'Available to order' };
      return { level: 'out', label: 'Out of stock' };
    }
    function html(q, tracked, cont) {
      if (!enabled()) return '';
      var s = compute(q, tracked, cont);
      return '<span class="ccs-stock ccs-stock--' + s.level + '">' +
        '<span class="ccs-stock__dot"></span>' +
        '<span class="ccs-stock__label">' + s.label + '</span></span>';
    }
    // Fill a container from a { variantId: {q,t,c} } map for one variant id.
    function renderInto(el, map, variantId) {
      if (!el) return;
      if (!enabled() || !map) { el.innerHTML = ''; return; }
      var v = map[variantId] || map[String(variantId)];
      el.innerHTML = v ? html(v.q, !!v.t, !!v.c) : '';
    }
    return { enabled: enabled, compute: compute, html: html, renderInto: renderInto, LOW: LOW };
  })();

   // ============================================
  // HERO SLIDESHOW
  // ============================================
  document.querySelectorAll('[data-slideshow]').forEach(slideshow => {
    const slides = slideshow.querySelectorAll('[data-slide]');
    const dots = slideshow.querySelectorAll('[data-slideshow-dot]');
    const prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    const nextBtn = slideshow.querySelector('[data-slideshow-next]');

    if (slides.length <= 1) return; // nothing to do

    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = parseInt(slideshow.dataset.interval, 10) || 6000;
    let current = 0;
    let timer = null;
    let isPaused = false;

    function goTo(index) {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', !active);
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.removeAttribute('aria-selected');
        }
      });
      current = index;
    }

    function next() { goTo((current + 1) % slides.length); }
    function prev() { goTo((current - 1 + slides.length) % slides.length); }

    function startAutoplay() {
      if (!autoplay || isPaused) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Button controls
    prevBtn?.addEventListener('click', () => { prev(); startAutoplay(); });
    nextBtn?.addEventListener('click', () => { next(); startAutoplay(); });

    // Dot controls
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.goto, 10));
        startAutoplay();
      });
    });

    // Pause on hover (desktop)
    slideshow.addEventListener('mouseenter', () => { isPaused = true; stopAutoplay(); });
    slideshow.addEventListener('mouseleave', () => { isPaused = false; startAutoplay(); });

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    // Touch swipe
    let touchStartX = 0;
    let touchEndX = 0;
    slideshow.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    slideshow.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
        startAutoplay();
      }
    }, { passive: true });

    // Keyboard — when slideshow is focused
    slideshow.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { next(); startAutoplay(); }
    });

    // Start
    startAutoplay();
  });

  // ============================================
  // CART COUNT
  // ============================================
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.ccs-cart-link__count').forEach(b => {
          b.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  // ============================================
  // ADD TO CART
  // ============================================
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const qty = parseInt(document.querySelector('[data-qty]')?.value || 1);
      if (!variantId || btn.disabled) return;
      // Instant feedback: show a spinner while the request is in flight.
      const orig = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="ccs-btn-spinner" aria-hidden="true"></span><span>Adding…</span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(r => r.json())
        .then((data) => {
          btn.classList.remove('is-loading');
          if (data && data.status) {
            // Shopify returned an error (e.g. sold out) — restore the button.
            btn.innerHTML = orig; btn.disabled = false;
            return;
          }
          updateCartCount();
          btn.innerHTML = '<span>Added</span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
          btn.style.background = '#22c55e';
          setTimeout(() => {
            btn.innerHTML = orig;
            btn.style.background = '';
            btn.disabled = false;
          }, 1800);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.innerHTML = orig;
          btn.disabled = false;
        });
    });
  });

  // ============================================
  // QTY SELECTOR
  // ============================================
  const qtyInput = document.querySelector('[data-qty]');
  document.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
  });
  document.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  // (Cart remove is handled live in the CART PAGE block below — no reload.)

  // ============================================
  // DESKTOP MEGA MENU — hover + click + keyboard
  // ============================================
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  function closeAllDropdowns(except) {
    dropdowns.forEach(d => {
      if (d === except) return;
      d.classList.remove('is-open');
      const trig = d.querySelector('[data-dropdown-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    });
  }

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    if (!trigger) return;

    // Click toggles — but only on the chevron area or if keyboard
    // Allow normal link click-through to the category page
    trigger.addEventListener('click', function (e) {
      // If user clicked on the chevron SVG, toggle dropdown instead of navigating
      const clickedChevron = e.target.closest('.ccs-nav-item__chevron');
      if (clickedChevron) {
        e.preventDefault();
        const isOpen = dropdown.classList.contains('is-open');
        closeAllDropdowns(isOpen ? null : dropdown);
        dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      }
      // Otherwise let the link navigate normally
    });

    // Keyboard support
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        // Only intercept if it opens the dropdown, let Enter on link still navigate
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          closeAllDropdowns(dropdown);
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          const firstLink = dropdown.querySelector('.ccs-nav-dropdown__link');
          if (firstLink) firstLink.focus();
        }
      } else if (e.key === 'Escape') {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Arrow key navigation within dropdown
    const dropLinks = dropdown.querySelectorAll('.ccs-nav-dropdown__link');
    dropLinks.forEach((link, i) => {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          (dropLinks[i + 1] || dropLinks[0]).focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          (dropLinks[i - 1] || dropLinks[dropLinks.length - 1]).focus();
        } else if (e.key === 'Escape') {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) {
      closeAllDropdowns(null);
    }
  });

  // ============================================
  // MOBILE DRAWER
  // ============================================
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openBtn = document.querySelector('[data-mobile-open]');
  const closeBtn = document.querySelector('[data-mobile-close]');

  function openDrawer() {
  if (!drawer || !overlay) return;
  drawer.classList.add('is-open');
  overlay.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('ccs-drawer-open');
}

function closeDrawer() {
  if (!drawer || !overlay) return;
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('ccs-drawer-open');
}

  openBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  // Escape closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer?.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Drawer accordion
  document.querySelectorAll('[data-drawer-toggle]').forEach(btn => {
    btn.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const panel = this.nextElementSibling;
      this.setAttribute('aria-expanded', !expanded);
      if (panel) panel.hidden = expanded;
    });
  });

  // ============================================
  // ACTIVE NAV (belt & suspenders — Liquid also sets this)
  // ============================================
  const path = window.location.pathname;
  document.querySelectorAll('.ccs-nav-item__trigger, .ccs-drawer__link, .ccs-drawer__sublink').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('active');
  });

   // ============================================
  // PRODUCT GALLERY
  // ============================================
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    function show(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        show(parseInt(thumb.dataset.goto, 10));
      });
    });
  });

  // ============================================
  // PRODUCT FORM — variant switching
  // ============================================
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    const productJsonEl = document.querySelector('[data-product-json]');
    const variantIdInput = productForm.querySelector('[data-variant-id-input]');
    const priceEl = document.querySelector('[data-price]');
    const comparePriceEl = document.querySelector('[data-compare-price]');
    const priceWrap = document.querySelector('[data-price-wrap]');
    const addBtn = productForm.querySelector('[data-add-btn]');
    const addLabel = productForm.querySelector('[data-add-label]');
    const skuEl = document.querySelector('[data-sku]');
    const optionSelects = productForm.querySelectorAll('[data-variant-option]');

    let productData = null;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (err) {
      console.error('Product JSON parse failed:', err);
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }

    var b2bPdpEl = document.querySelector('[data-b2b-pdp]');
    // B2B stock badge (Liquid renders the initial variant; we keep it in sync as
    // the shopper switches variants). Map + element exist only for b2b customers.
    var stockPdpEl = document.querySelector('[data-stock-pdp]');
    var pdpStockMap = null;
    if (stockPdpEl) { try { pdpStockMap = JSON.parse(stockPdpEl.getAttribute('data-stock-map') || 'null'); } catch (e) {} }
    function updatePdpStock(match) {
      if (stockPdpEl && match && window.CCSStock) window.CCSStock.renderInto(stockPdpEl, pdpStockMap, match.id);
    }
    function updatePdpB2B(match) {
      if (!b2bPdpEl || !window.CCSB2B || !match) return;
      var html = CCSB2B.panelHTML(match.sku, match.price);
      if (html) {
        b2bPdpEl.innerHTML = html;
        b2bPdpEl.hidden = false;
        if (priceWrap) priceWrap.classList.add('is-b2b-active'); // hide the plain retail line (panel shows it)
      } else {
        b2bPdpEl.hidden = true;
        if (priceWrap) priceWrap.classList.remove('is-b2b-active');
      }
    }
    function currentMatch() {
      if (!productData) return null;
      if (!optionSelects.length) return productData.variants[0];
      var vals = Array.from(optionSelects).map(function (s) { return s.value; });
      return productData.variants.find(function (v) { return v.options.every(function (opt, i) { return opt === vals[i]; }); }) || productData.variants[0];
    }

    function updateVariant() {
      if (!productData) return;
      const selectedValues = Array.from(optionSelects).map(s => s.value);
      const match = productData.variants.find(v =>
        v.options.every((opt, i) => opt === selectedValues[i])
      );

      if (!match) return;

      // Update hidden input
      variantIdInput.value = match.id;

      // Update URL without reload (for shareable link)
      if (history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }

      // Update price
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      updatePdpB2B(match);
      updatePdpStock(match);

      // Compare-at price
      if (priceWrap) {
        let compare = priceWrap.querySelector('[data-compare-price]');
        if (match.compare_at_price && match.compare_at_price > match.price) {
          if (!compare) {
            compare = document.createElement('span');
            compare.className = 'ccs-product-single__price-compare';
            compare.setAttribute('data-compare-price', '');
            priceWrap.insertBefore(compare, priceWrap.firstChild);
          }
          compare.textContent = formatMoney(match.compare_at_price);
        } else if (compare) {
          compare.remove();
        }
      }

      // Update SKU
      if (skuEl && match.sku) {
        skuEl.innerHTML = '<strong>SKU:</strong> ' + match.sku;
      }

      // Update button state
      if (match.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold Out';
      }

      // Broadcast so apps (Wishify, etc.) can react
      document.dispatchEvent(new CustomEvent('variant:change', { detail: match }));
    }

    optionSelects.forEach(sel => sel.addEventListener('change', updateVariant));

    // Show the B2B "your price" for the initial variant once pricing loads.
    // CCSB2B is defined later in this file, so wait for its ready event (and also
    // handle the case where it's already loaded, e.g. on a client-side re-render).
    document.addEventListener('ccsb2b:ready', function () { updatePdpB2B(currentMatch()); });
    if (window.CCSB2B && window.CCSB2B.isB2B && window.CCSB2B.isB2B()) { updatePdpB2B(currentMatch()); }

    // AJAX add to cart (prevents full page reload)
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) {
            // Error (e.g., out of stock)
            if (addLabel) addLabel.textContent = data.description || 'Error';
            setTimeout(() => { if (addLabel) addLabel.textContent = 'Add to Cart'; }, 2000);
            return;
          }

          // Success
          updateCartCount();
          const origLabel = addLabel?.textContent;
          if (addLabel) addLabel.textContent = '✓ Added to Cart!';
          addBtn.style.background = '#22c55e';
          setTimeout(() => {
            if (addLabel) addLabel.textContent = origLabel || 'Add to Cart';
            addBtn.style.background = '';
          }, 2000);
        })
        .catch(err => {
          console.error('Add to cart failed:', err);
        });
    });
  }

    // ============================================
  // QUICK VIEW MODAL
  // ============================================
  const modal = document.querySelector('[data-quickview-modal]');
  const modalBody = document.querySelector('[data-quickview-body]');

  function openQuickView(handle, stockMapJson) {
    if (!modal || !modalBody) return;
    var stockMap = null;
    if (stockMapJson) { try { stockMap = JSON.parse(stockMapJson); } catch (e) {} }
    modalBody.innerHTML = '<div class="ccs-modal__loading">Loading…</div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ccs-modal-open');

    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        const img = product.featured_image
          ? `<img src="${product.featured_image}" alt="${product.title}">`
          : '<svg viewBox="0 0 24 24" width="72" height="72" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color:var(--blue-brand);"><path d="M16.5 9.4 7.5 4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05"/><path d="M12 22.08V12"/></svg>';

        const price = (product.price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
        const compareHtml = (product.compare_at_price && product.compare_at_price > product.price)
          ? `<s class="ccs-quickview__was">${(product.compare_at_price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })}</s>`
          : '';

        const desc = product.description
          ? product.description.replace(/<[^>]*>/g, '').slice(0, 200) + (product.description.length > 200 ? '…' : '')
          : '';

        const hasVariants = product.variants.length > 1;
        const firstVariant = product.variants[0];
        const available = product.available;

        var qvMoney = function (c) { return (c / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }); };
        function qvOptRow(v) {
          var b2b = (window.CCSB2B && CCSB2B.net(v.sku));
          var priceHtml = (b2b && b2b < v.price)
            ? '<span class="ccs-qv-opt__yours">' + qvMoney(b2b) + '</span><span class="ccs-qv-opt__retail">' + qvMoney(v.price) + '</span>'
            : '<span class="ccs-qv-opt__yours">' + qvMoney(v.price) + '</span>';
          return '<li role="option">' +
            '<button type="button" class="ccs-qv-opt' + (!v.available ? ' is-disabled' : '') + '" data-qv-opt data-variant-id="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' +
              '<span class="ccs-qv-opt__title">' + v.title + (!v.available ? ' — Sold Out' : '') + '</span>' +
              '<span class="ccs-qv-opt__prices">' + priceHtml + '</span>' +
            '</button></li>';
        }
        let variantSelectorHtml = '';
        if (hasVariants) {
          variantSelectorHtml =
            '<div class="ccs-qv-variants" data-qv-select>' +
              '<label class="ccs-qv-variants__label">Variant</label>' +
              '<button type="button" class="ccs-qv-variants__btn" data-qv-select-btn aria-haspopup="listbox" aria-expanded="false">' +
                '<span data-qv-select-label>' + firstVariant.title + '</span>' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
              '</button>' +
              '<ul class="ccs-qv-variants__list" data-qv-select-list role="listbox" hidden>' +
                product.variants.map(qvOptRow).join('') +
              '</ul>' +
            '</div>';
        }

        modalBody.innerHTML = `
          <div class="ccs-quickview">
            <div class="ccs-quickview__gallery">${img}</div>
            <div class="ccs-quickview__info">
              ${product.type ? `<div class="ccs-badge" style="margin-bottom:10px;">${product.type}</div>` : ''}
              <h2>${product.title}</h2>
              <div class="ccs-quickview__price">
                ${compareHtml}<span data-qv-price>${price}</span>
              </div>
              <div class="ccs-quickview__b2b" data-qv-b2b hidden></div>
              <div class="ccs-quickview__stock" data-qv-stock></div>
              ${desc ? `<p class="ccs-quickview__desc">${desc}</p>` : ''}
              ${variantSelectorHtml}
              <div style="margin-bottom:16px;">
                <label style="display:block;font-size:13px;font-weight:600;color:var(--text-dark);margin-bottom:6px;">Quantity</label>
                <div class="ccs-qty-selector">
                  <button type="button" data-qv-minus aria-label="Decrease">−</button>
                  <input type="number" value="1" min="1" data-qv-qty>
                  <button type="button" data-qv-plus aria-label="Increase">+</button>
                </div>
              </div>
              <button type="button"
                      class="ccs-btn ccs-btn--primary ccs-btn--full"
                      data-qv-add
                      data-variant-id="${firstVariant.id}"
                      ${!available ? 'disabled' : ''}>
                ${available ? 'Add to Cart' : 'Sold Out'}
              </button>
              <a href="${product.url}" class="ccs-quickview__link">View full details</a>
            </div>
          </div>
        `;

        // Wire up quick view interactions
        const qvAddBtn = modalBody.querySelector('[data-qv-add]');
        const qvPriceEl = modalBody.querySelector('[data-qv-price]');
        const qvQtyInput = modalBody.querySelector('[data-qv-qty]');
        const qvB2bEl = modalBody.querySelector('[data-qv-b2b]');
        const qvStockEl = modalBody.querySelector('[data-qv-stock]');

        function qvUpdateB2B(variant) {
          if (!qvB2bEl || !window.CCSB2B) return;
          var html = CCSB2B.priceHTML(variant.sku, variant.price);
          if (html) { qvB2bEl.innerHTML = html; qvB2bEl.hidden = false; }
          else { qvB2bEl.hidden = true; }
        }
        function qvUpdateStock(variant) {
          if (window.CCSStock) window.CCSStock.renderInto(qvStockEl, stockMap, variant.id);
        }
        if (window.CCSB2B) { CCSB2B.ready.then(function () { qvUpdateB2B(firstVariant); }); }
        qvUpdateStock(firstVariant);

        function qvSelectVariant(variant) {
          if (!variant) return;
          qvAddBtn.dataset.variantId = variant.id;
          qvPriceEl.textContent = (variant.price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
          qvUpdateB2B(variant);
          qvUpdateStock(variant);
          if (variant.available) { qvAddBtn.disabled = false; qvAddBtn.textContent = 'Add to Cart'; }
          else { qvAddBtn.disabled = true; qvAddBtn.textContent = 'Sold Out'; }
          var labelEl = modalBody.querySelector('[data-qv-select-label]');
          if (labelEl) labelEl.textContent = variant.title;
        }

        // Custom variant dropdown (styled so retail can be shown struck-through)
        var qvSelectWrap = modalBody.querySelector('[data-qv-select]');
        if (qvSelectWrap) {
          var qvBtn = qvSelectWrap.querySelector('[data-qv-select-btn]');
          var qvList = qvSelectWrap.querySelector('[data-qv-select-list]');
          function qvCloseList() { qvList.hidden = true; qvBtn.setAttribute('aria-expanded', 'false'); qvSelectWrap.classList.remove('is-open'); }
          qvBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            var willOpen = qvList.hidden;
            qvList.hidden = !willOpen;
            qvBtn.setAttribute('aria-expanded', String(willOpen));
            qvSelectWrap.classList.toggle('is-open', willOpen);
          });
          qvList.querySelectorAll('[data-qv-opt]').forEach(function (opt) {
            opt.addEventListener('click', function () {
              var id = parseInt(opt.getAttribute('data-variant-id'), 10);
              var variant = product.variants.find(function (v) { return v.id === id; });
              qvSelectVariant(variant);
              qvCloseList();
            });
          });
          document.addEventListener('click', function (e) {
            if (qvSelectWrap && !qvSelectWrap.contains(e.target)) qvCloseList();
          });
        }

        modalBody.querySelector('[data-qv-minus]')?.addEventListener('click', () => {
          if (parseInt(qvQtyInput.value) > 1) qvQtyInput.value = parseInt(qvQtyInput.value) - 1;
        });
        modalBody.querySelector('[data-qv-plus]')?.addEventListener('click', () => {
          qvQtyInput.value = parseInt(qvQtyInput.value) + 1;
        });

        qvAddBtn?.addEventListener('click', () => {
          if (qvAddBtn.disabled) return;
          const variantId = qvAddBtn.dataset.variantId;
          const qty = parseInt(qvQtyInput.value) || 1;
          const qvOrig = qvAddBtn.innerHTML;
          qvAddBtn.disabled = true;
          qvAddBtn.innerHTML = '<span class="ccs-btn-spinner" aria-hidden="true"></span><span>Adding…</span>';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          })
            .then(r => r.json())
            .then(data => {
              if (data.status) {
                qvAddBtn.textContent = data.description || 'Error';
                qvAddBtn.disabled = false;
                return;
              }
              updateCartCount();
              qvAddBtn.innerHTML = 'Added <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;"><polyline points="20 6 9 17 4 12"/></svg>';
              qvAddBtn.style.background = '#22c55e';
              setTimeout(() => { closeQuickView(); }, 1000);
            })
            .catch(() => { qvAddBtn.innerHTML = qvOrig; qvAddBtn.disabled = false; });
        });
      })
      .catch(() => {
        modalBody.innerHTML = '<div class="ccs-modal__loading">Unable to load product. Please try the full product page.</div>';
      });
  }

  function closeQuickView() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ccs-modal-open');
    setTimeout(() => { if (modalBody) modalBody.innerHTML = ''; }, 200);
  }

  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-quickview-open]');
    if (trigger) {
      e.preventDefault();
      var qvCard = trigger.closest('[data-stock-map]');
      openQuickView(trigger.dataset.productHandle, qvCard && qvCard.getAttribute('data-stock-map'));
      return;
    }
    if (e.target.closest('[data-quickview-close]')) {
      closeQuickView();
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal?.classList.contains('is-open')) {
      closeQuickView();
    }
  });

    // ============================================
  // FAKE VIEWER COUNTER
  // ============================================
  document.querySelectorAll('[data-fake-view]').forEach(el => {
    const min = parseInt(el.dataset.min, 10) || 5;
    const max = parseInt(el.dataset.max, 10) || 20;
    const duration = parseInt(el.dataset.duration, 10) || 8000;

    function randomCount() {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    el.textContent = randomCount();
    setInterval(() => { el.textContent = randomCount(); }, duration);
  });


  // ============================================
  // COLLECTION SIDEBAR — sort & tag filter
  // ============================================
  document.querySelectorAll('[data-sort-select]').forEach(select => {
    select.addEventListener('change', function () {
      if (this.value) window.location.href = this.value;
    });
  });

  document.querySelectorAll('[data-tag-filter]').forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      const targetUrl = this.dataset.targetUrl;
      if (targetUrl) window.location.href = targetUrl;
    });
  });


  const contactForm = document.querySelector('.ccs-contact-form form');
  if (contactForm) {
    const enquirySelect = contactForm.querySelector('[data-enquiry-type]');
    const messageBody = contactForm.querySelector('[data-enquiry-body]');

    if (enquirySelect && messageBody) {
      contactForm.addEventListener('submit', function () {
        const enquiryType = enquirySelect.value;
        const currentBody = messageBody.value.trim();
        const prefix = `[Enquiry Type: ${enquiryType}]\n\n`;

        // Only prepend if not already there
        if (!currentBody.startsWith('[Enquiry Type:')) {
          messageBody.value = prefix + currentBody;
        }
      });
    }
  }

  // ============================================
// CART PAGE — qty stepper + order note toggle
// ============================================
(function () {
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var timers = {};

  // Shopify-style money formatter (cents -> shop's money format).
  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(num, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      var n = (num / 100).toFixed(precision).split('.');
      var dollars = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (n[1] ? decimal + n[1] : '');
    }
    var m = moneyFormat.match(placeholder);
    var token = m ? m[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ','); break;
      default: value = withDelims(cents, 2);
    }
    return moneyFormat.replace(placeholder, value);
  }

  function setAll(sel, fn) { document.querySelectorAll(sel).forEach(fn); }
  function cssEsc(s) { return String(s).replace(/"/g, '\\"'); }

  // Parse displayed money back to cents (AUD: "$1,234.50" -> 123450).
  function parseCents(text) {
    var n = parseFloat(String(text).replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  // Count-up/down a money element to a new cents value (easeOutCubic).
  function animateMoney(el, toCents) {
    if (!el) return;
    var fromCents = (el._cents != null) ? el._cents : parseCents(el.textContent);
    el._cents = toCents;
    if (fromCents === toCents) { el.textContent = formatMoney(toCents); return; }
    var dur = 450, start = null;
    function tick(now) {
      if (start == null) start = now;
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatMoney(Math.round(fromCents + (toCents - fromCents) * eased));
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = formatMoney(toCents);
    }
    requestAnimationFrame(tick);
  }

  // Re-render everything from the returned cart JSON — no page reload.
  function renderCart(cart) {
    if (!cart || !cart.items || cart.item_count === 0) { location.reload(); return; }

    // Match each DOM row to a cart item by VARIANT ID, not by item.key. A line
    // item's key hash can change once a Shopify Function trade-price discount is
    // applied, so after a quantity change the returned key no longer matches the
    // key rendered at page load — which made the old key-diff delete the row (it
    // "vanished" until a manual refresh). Variant id is stable, so we match on
    // it, refresh each row's now-stale key, and only remove rows genuinely gone
    // from the cart.
    var byVariant = {};
    cart.items.forEach(function (it) {
      (byVariant[it.variant_id] = byVariant[it.variant_id] || []).push(it);
    });
    var used = {};
    setAll('.ccs-cart-line', function (line) {
      var vid = line.getAttribute('data-variant-id');
      var list = byVariant[vid] || [];
      var it = list[used[vid] || 0];
      if (!it) { line.remove(); return; }   // no longer in the cart
      used[vid] = (used[vid] || 0) + 1;

      // Refresh the (possibly changed) key so future +/- and remove hit this row.
      line.setAttribute('data-line-key', it.key);
      line.querySelectorAll('[data-cart-remove]').forEach(function (b) {
        b.setAttribute('data-cart-remove', it.key);
      });

      var totalEl = line.querySelector('[data-line-total]');
      if (totalEl) animateMoney(totalEl, it.final_line_price);

      // Keep the struck-through retail "was" price and the trade-discount amount
      // in sync as the quantity scales them.
      var wasEl = line.querySelector('[data-line-was]');
      if (wasEl && it.original_line_price !== it.final_line_price) {
        wasEl.textContent = formatMoney(it.original_line_price);
      }
      var allocs = it.line_level_discount_allocations || [];
      line.querySelectorAll('[data-line-discount]').forEach(function (row, di) {
        var amtEl = row.querySelector('[data-discount-amount]');
        if (amtEl && allocs[di]) amtEl.textContent = formatMoney(allocs[di].amount);
      });

      var qtyEl = line.querySelector('[data-qty-input]');
      if (qtyEl && String(it.quantity) !== qtyEl.value) qtyEl.value = it.quantity;
      line.classList.remove('is-updating');
    });

    setAll('[data-cart-subtotal]', function (el) { animateMoney(el, cart.items_subtotal_price); });
    setAll('[data-cart-total]', function (el) { animateMoney(el, cart.total_price); });
    setAll('[data-cart-count]', function (el) { el.textContent = cart.item_count; });
    setAll('[data-cart-count-word]', function (el) { el.textContent = cart.item_count === 1 ? 'item' : 'items'; });

    var badge = document.querySelector('.ccs-cart-link__count');
    if (badge) badge.textContent = cart.item_count;

    var ship = document.querySelector('[data-cart-ship]');
    if (ship) {
      var threshold = parseInt(ship.getAttribute('data-free-threshold'), 10) || 30000;
      var textEl = ship.querySelector('[data-ship-text]');
      var fillEl = ship.querySelector('[data-ship-fill]');
      var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
      if (fillEl) fillEl.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        ship.classList.add('is-unlocked');
        if (textEl) textEl.innerHTML = "<strong>You've unlocked FREE delivery</strong> for most Melbourne suburbs";
      } else {
        ship.classList.remove('is-unlocked');
        if (textEl) textEl.innerHTML = "You're <strong>" + formatMoney(threshold - cart.total_price) +
          "</strong> away from <strong>FREE delivery</strong> in most Melbourne suburbs";
      }
    }
    document.dispatchEvent(new CustomEvent('ccs:cart-rendered', { detail: cart })); // the delivery check re-prices itself
  }

  // Change a cart line by its 1-based LINE NUMBER, not its key. A line item's key
  // hash changes once a Shopify Function trade-price discount is on the line, so a
  // key captured at page load gets rejected by /cart/change.js — which showed up
  // as: clicking "+" errored, reloaded, and reverted to the old quantity. The line
  // index is stable for the request and immune to that.
  function changeLine(lineNo, qty, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineNo, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) { location.reload(); return; }  // error payload, not a cart
        renderCart(cart);
      })
      .catch(function () { location.reload(); });
  }

  // 1-based position of a line among the current cart rows — what /cart/change.js
  // expects as `line`. Recomputed at call time so it stays correct after edits.
  function lineIndexOf(lineEl) {
    if (!lineEl) return null;
    var lines = document.querySelectorAll('.ccs-cart-line');
    for (var i = 0; i < lines.length; i++) { if (lines[i] === lineEl) return i + 1; }
    return null;
  }

  // +/- steppers (debounced so rapid clicks send once)
  setAll('[data-qty-step]', function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(this.dataset.qtyStep, 10);
      var wrap = this.closest('.ccs-qty-stepper');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      var line = this.closest('.ccs-cart-line');
      if (!line) return;
      line.classList.add('is-updating');
      var tkey = line.getAttribute('data-variant-id') || 'l';
      clearTimeout(timers[tkey]);
      timers[tkey] = setTimeout(function () {
        var no = lineIndexOf(line);
        if (no) changeLine(no, next, line);
      }, 400);
    });
  });

  // Manual typing
  setAll('.ccs-qty-stepper [data-qty-input]', function (input) {
    input.addEventListener('change', function () {
      var next = Math.max(0, parseInt(this.value, 10) || 0);
      this.value = next;
      var line = this.closest('.ccs-cart-line');
      if (!line) return;
      var tkey = line.getAttribute('data-variant-id') || 'l';
      clearTimeout(timers[tkey]);
      timers[tkey] = setTimeout(function () {
        var no = lineIndexOf(line);
        if (no) changeLine(no, next, line);
      }, 250);
    });
  });

  // Remove (live, no reload)
  setAll('[data-cart-remove]', function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.closest('.ccs-cart-line');
      var no = lineIndexOf(line);
      if (!no) return;
      changeLine(no, 0, line);
    });
  });
})();

// Cart page: "Check delivery to your postcode". Asks our delivery planner what the checkout
// would offer that postcode for this cart, and shows exactly those options. When we do not
// deliver there, the checkout button is switched off and a pickup link takes its place.
// The postcode is remembered on this device, so the answer is back on the next visit.
(function () {
  var box = document.querySelector('[data-delivery-check]');
  if (!box) return;
  var input = box.querySelector('[data-delivery-postcode]');
  var go = box.querySelector('[data-delivery-go]');
  var out = box.querySelector('[data-delivery-out]');
  var checkout = document.querySelector('[data-checkout-btn]');
  var subtotal = parseInt(box.getAttribute('data-subtotal'), 10) || 0; // cents
  var asked = 0; // only the latest answer is shown
  var money = function (cents) { return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  function show(html, state) {
    out.innerHTML = html;
    out.hidden = !html;
    box.setAttribute('data-state', state || '');
    if (checkout) checkout.disabled = state === 'no';
  }

  function render(d, postcode) {
    if (d && d.deliverable === true) {
      return show('<p class="ccs-cart-delivery__head">Delivery to ' + esc(postcode) + '</p><ul class="ccs-cart-delivery__options">' +
        d.options.map(function (o) {
          return '<li><span><strong>' + esc(o.name) + '</strong><small>' + esc(o.detail) + '</small></span>' +
            '<b' + (o.price ? '' : ' class="is-free"') + '>' + (o.price ? money(o.price) : 'FREE') + '</b></li>';
        }).join('') + '</ul><p class="ccs-cart-delivery__foot">These are the options checkout will offer for this postcode.</p>', 'yes');
    }
    if (d && d.deliverable === false) {
      var why = d.reason === 'no_day_open' ? 'No delivery day is open for ' + esc(postcode) + ' right now. Call us on <a href="tel:1300312276">1300 312 276</a>.'
        : d.reason === 'below_minimum' ? 'Delivery to ' + esc(postcode) + ' needs an order of at least ' + money((d.minOrder || 0) * 100) + '.'
        : 'Sorry, we do not deliver to ' + esc(postcode) + '. Our van covers Melbourne, up to about 120 km from Springvale.';
      return show('<p class="ccs-cart-delivery__no">' + why + '</p>' +
        '<button type="submit" name="checkout" class="ccs-cart-delivery__pickup">Order for pickup from Springvale instead</button>', 'no');
    }
    show('<p class="ccs-cart-delivery__foot">We could not check ' + esc(postcode) + ' just now. Your delivery options will show at checkout.</p>', '');
  }

  function check() {
    var postcode = input.value.trim();
    try { localStorage.setItem('ccsPostcode', postcode); } catch (e) {}
    if (!postcode) return show('', '');
    if (!/^\d{4}$/.test(postcode)) return show('<p class="ccs-cart-delivery__foot">Enter a 4-digit postcode.</p>', '');
    var mine = ++asked;
    box.classList.add('is-loading');
    fetch('/apps/ccs/delivery/estimate?postcode=' + postcode + '&subtotal=' + (subtotal / 100), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (d) {
        if (mine !== asked) return;
        box.classList.remove('is-loading');
        render(d, postcode);
      });
  }

  go.addEventListener('click', check);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } }); // Enter must not submit the cart form
  input.addEventListener('input', function () { if (!input.value.trim()) check(); }); // clearing the box clears the answer
  document.addEventListener('ccs:cart-rendered', function (e) {
    subtotal = e.detail.items_subtotal_price;
    if (box.getAttribute('data-state')) check(); // the cart changed: the free-delivery threshold may have been crossed
  });
  try { input.value = localStorage.getItem('ccsPostcode') || ''; } catch (e) {}
  if (input.value) check();
})();

// Article: "On this page", built from the article's own section headings (h2). Shown when there
// are three or more; collapsed on small screens. The link of the section being read is marked.
(function () {
  var body = document.querySelector('[data-post-body]');
  var toc = document.querySelector('[data-post-toc]');
  if (!body || !toc) return;
  var heads = body.querySelectorAll('h2');
  if (heads.length < 3) return;
  var list = toc.querySelector('[data-post-toc-list]');
  var used = {};
  heads.forEach(function (h) {
    if (!h.id) {
      var id = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
      while (used[id] || document.getElementById(id)) id += '-2';
      h.id = id;
    }
    used[h.id] = true;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.hidden = false;
  if (window.matchMedia('(max-width: 1024px)').matches) toc.open = false;
  if (!('IntersectionObserver' in window)) return;
  var links = list.querySelectorAll('a');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      links.forEach(function (l) { l.classList.toggle('is-current', l.getAttribute('href') === '#' + e.target.id); });
    });
  }, { rootMargin: '-15% 0px -75% 0px' });
  heads.forEach(function (h) { io.observe(h); });
})();

// Order note expandable
document.querySelectorAll('[data-note-toggle]').forEach(btn => {
  btn.addEventListener('click', function () {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    const field = this.parentElement.querySelector('.ccs-cart-summary__note-field');
    this.setAttribute('aria-expanded', !expanded);
    if (field) field.hidden = expanded;
  });
});

// Auto-save the order note (replaces the removed "Update Cart" button). Saves on
// blur and, debounced, while typing — so the note persists even if the shopper
// leaves without checking out. /cart/update.js writes cart.note server-side.
(function () {
  var note = document.querySelector('.ccs-cart-summary__order-note textarea[name="note"]');
  if (!note) return;
  var last = note.value;
  var timer;
  function saveNote() {
    if (note.value === last) return;
    last = note.value;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () {});
  }
  note.addEventListener('blur', saveNote);
  note.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(saveNote, 800);
  });
})();

// ============================================
// PERSISTENT CART (logged-in customers, cross-device)
// Saves the logged-in customer's cart to the backend and reconciles it on load,
// so a cart started on one device continues on another. Same App Proxy pattern
// as the wishlist (GET only — logged-in POSTs aren't forwarded). On login we
// MERGE (reach max qty per variant so nothing from either device is lost); on a
// different customer using a shared browser we REPLACE with their saved cart.
// ============================================
(function () {
  var loggedIn = !!document.querySelector('.ccs-header__wishlist-btn[data-logged-in]');
  if (!loggedIn) return;

  var LS_KEY = 'ccs_cart_customer';
  var onCartPage = !!document.querySelector('[data-cart-root]');

  function currentItems() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.items || []).map(function (it) { return { id: it.id, quantity: it.quantity }; }); })
      .catch(function () { return []; });
  }
  function encode(items) { return items.map(function (it) { return it.id + ':' + it.quantity; }).join(','); }
  function saveRemote(items) {
    return fetch('/apps/ccs/cart/save?items=' + encodeURIComponent(encode(items)), { cache: 'no-store' }).catch(function () {});
  }
  function getRemote() {
    return fetch('/apps/ccs/cart/get', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [], customerId: null }; });
  }
  // Add items one at a time so one out-of-stock line can't fail the whole restore.
  function addItems(items) {
    return items.reduce(function (chain, it) {
      return chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.id, quantity: it.quantity })
        }).catch(function () {});
      });
    }, Promise.resolve());
  }
  function clearCart() { return fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}); }

  // Persist the browser cart whenever it changes — caught centrally by observing
  // fetch() calls to the cart write endpoints (works no matter which button/handler
  // triggered them). Debounced so a burst of changes sends one save.
  var saveTimer;
  var loggingOut = false;
  function scheduleSave() {
    if (loggingOut) return; // never persist the empty cart we clear on logout
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { currentItems().then(saveRemote); }, 700);
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { scheduleSave(); }, function () {});
    }
    return p;
  };

  // On logout: clear THIS browser's cart so the next person/guest doesn't inherit
  // it. The customer's cart stays saved in the backend (keyed by their id) and is
  // restored next time they log in. We suppress the auto-save so the clear doesn't
  // overwrite their saved cart with an empty one.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="/account/logout"]') : null;
    if (!a) return;
    e.preventDefault();
    loggingOut = true;
    clearTimeout(saveTimer);
    // Mark a clean logout: the next login on this browser starts from a clean
    // state, so any items added meanwhile (as a guest) sum into that cart.
    try { localStorage.removeItem(LS_KEY); } catch (err) {}
    var navigated = false;
    var go = function () { if (navigated) return; navigated = true; window.location.href = a.href; };
    // 1) Persist the latest cart to the backend (so nothing added in the last
    // moment is lost), 2) clear THIS browser's cart, 3) log out.
    currentItems()
      .then(saveRemote)
      .then(function () { return origFetch('/cart/clear.js', { method: 'POST' }); })
      .then(go, go);
    setTimeout(go, 2000); // safety: don't get stuck if a request hangs
  }, true);

  // Loading UI: a spinner on the header cart icon (all pages) and, on the cart
  // page, a full overlay so the shopper never sees a partial/empty cart flash
  // mid-merge. Soft-shown after 350ms for the initial fetch (so fast, no-merge
  // visits don't flash), or shown immediately once a merge is confirmed.
  var cartRoot = document.querySelector('[data-cart-root]');
  var cartLink = document.querySelector('.ccs-cart-link');
  var loaderEl = null, loaderTimer = null, reloading = false;
  function applyLoading() {
    if (cartLink) cartLink.classList.add('is-cart-loading');
    if (onCartPage && cartRoot && !loaderEl) {
      loaderEl = document.createElement('div');
      loaderEl.className = 'ccs-cart-loading';
      loaderEl.innerHTML = '<div class="ccs-cart-loading__spinner" aria-hidden="true"></div><p>Loading your cart…</p>';
      cartRoot.appendChild(loaderEl);
      cartRoot.classList.add('is-cart-loading');
    }
  }
  function showLoadingSoon() { loaderTimer = setTimeout(applyLoading, 350); }
  function showLoadingNow() { clearTimeout(loaderTimer); applyLoading(); }
  function hideLoading() {
    clearTimeout(loaderTimer);
    if (loaderEl) { loaderEl.remove(); loaderEl = null; }
    if (cartRoot) cartRoot.classList.remove('is-cart-loading');
    if (cartLink) cartLink.classList.remove('is-cart-loading');
  }

  // Wait until the native cart actually contains every expected variant before we
  // trust it / reload. Rapid sequential /cart/add.js writes can be briefly
  // inconsistent, which showed a partial cart on reload (badge right, lines short).
  function waitForItems(ids) {
    var tries = 0;
    function check() {
      return currentItems().then(function (items) {
        var have = {};
        items.forEach(function (it) { have[it.id] = true; });
        var missing = ids.some(function (id) { return !have[id]; });
        if (!missing || tries >= 6) return;
        tries++;
        return new Promise(function (res) { setTimeout(res, 250); }).then(check);
      });
    }
    return check();
  }

  // On load: reconcile the saved cart with this browser's cart. Three cases,
  // decided by localStorage[LS_KEY] = the customer who last "claimed" this
  // browser's cart (cleared on a clean logout):
  //   • CLAIMED  (== this customer)  -> ongoing session/cross-device: idempotent
  //       PULL only (never sum, so refreshing can't double quantities).
  //   • CLEAN    (no marker)         -> fresh login/signup after guest browsing:
  //       the browser cart is the guest's just-added items -> SUM with the saved
  //       cart (overlapping items increase; distinct items join).
  //   • OTHER    (a different id)    -> a previous customer's cart is lingering
  //       (they didn't cleanly log out) -> REPLACE, don't leak it to this login.
  showLoadingSoon();
  getRemote().then(function (remote) {
    var saved = (remote && remote.items) || [];
    var customerId = remote && remote.customerId;
    var lastCustomer = null;
    try { lastCustomer = localStorage.getItem(LS_KEY); } catch (e) {}
    var claimed = lastCustomer && customerId && String(lastCustomer) === String(customerId);
    var cleanState = !lastCustomer;
    try { if (customerId) localStorage.setItem(LS_KEY, String(customerId)); } catch (e) {}

    return currentItems().then(function (browser) {
      var byId = {};
      browser.forEach(function (it) { byId[it.id] = it.quantity; });
      var union = {};
      browser.forEach(function (it) { union[it.id] = 1; });
      saved.forEach(function (it) { union[it.id] = 1; });

      var work = null, expectedIds = null;
      if (claimed) {
        // Pull anything the browser is missing/short on (cross-device continuation).
        var pull = [];
        saved.forEach(function (it) {
          var cur = byId[it.id] || 0;
          if (it.quantity > cur) pull.push({ id: it.id, quantity: it.quantity - cur });
        });
        if (pull.length) { work = addItems(pull); expectedIds = Object.keys(union).map(Number); }
      } else if (cleanState) {
        // SUM the guest's browser cart with the saved cart: adding the saved
        // quantity on top of the guest quantity increases overlaps and joins the rest.
        if (saved.length) { work = addItems(saved); expectedIds = Object.keys(union).map(Number); }
      } else {
        // Different customer's lingering cart -> replace with this customer's saved cart.
        if (saved.length || browser.length) {
          work = clearCart().then(function () { return addItems(saved); });
          expectedIds = saved.map(function (it) { return it.id; });
        }
      }

      if (!work) { scheduleSave(); return; } // nothing to change; just persist current cart
      showLoadingNow();
      // Only reload/finish once the cart truly reflects everything we added.
      return work
        .then(function () { return waitForItems(expectedIds || []); })
        .then(function () {
          currentItems().then(saveRemote);
          if (typeof updateCartCount === 'function') updateCartCount();
          // Cart PAGE is server-rendered — reload once so the lines match the now
          // fully-consistent cart (idempotent: next load has nothing to merge).
          if (onCartPage) { reloading = true; location.reload(); }
        });
    });
  }).then(function () {
    if (!reloading) hideLoading();
  }, function () { hideLoading(); });
})();

// ============================================
// SDS PDF VIEWER MODAL
// ============================================
const sdsModal = document.querySelector('[data-sds-modal]');
const sdsIframe = document.querySelector('[data-sds-iframe]');
const sdsModalTitle = document.querySelector('[data-sds-modal-title]');
const sdsModalDownload = document.querySelector('[data-sds-modal-download]');
let sdsLoadTimer = null;
let sdsCurrentUrl = null;
// The modal is rendered inside the sticky product info column, which traps its z-index:
// the gallery image, header and reviews painted over it. Moving it to <body> frees it.
if (sdsModal) document.body.appendChild(sdsModal);

function openSds(url, title) {
  // On mobile, skip the modal — open in new tab (browser handles PDF natively)
  if (window.matchMedia('(max-width: 768px)').matches) {
    window.open(url, '_blank', 'noopener');
    return;
  }
  if (!sdsModal || !sdsIframe) {
    window.open(url, '_blank', 'noopener');
    return;
  }

  sdsCurrentUrl = url;
  sdsIframe.src = url;
  if (sdsModalTitle) sdsModalTitle.textContent = title || 'Safety Data Sheet';
  if (sdsModalDownload) sdsModalDownload.href = url;
  sdsModal.classList.add('is-open');
  sdsModal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('ccs-sds-modal-open');

  // Fallback: if iframe doesn't load within 3 seconds (likely blocked by extension),
  // close the modal and open in a new tab instead.
  if (sdsLoadTimer) clearTimeout(sdsLoadTimer);
  let loaded = false;

  sdsIframe.onload = function () {
    loaded = true;
    if (sdsLoadTimer) clearTimeout(sdsLoadTimer);
  };

  sdsLoadTimer = setTimeout(() => {
    if (!loaded && sdsModal.classList.contains('is-open')) {
      // Iframe never fired load — likely blocked. Bail to new tab.
      closeSds();
      window.open(url, '_blank', 'noopener');
    }
  }, 3000);
}

function closeSds() {
  if (!sdsModal) return;
  sdsModal.classList.remove('is-open');
  sdsModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('ccs-sds-modal-open');
  if (sdsLoadTimer) {
    clearTimeout(sdsLoadTimer);
    sdsLoadTimer = null;
  }
  if (sdsIframe) {
    setTimeout(() => { sdsIframe.src = ''; }, 250);
  }
}

document.querySelectorAll('[data-sds-view]').forEach(btn => {
  btn.addEventListener('click', function () {
    openSds(this.dataset.sdsUrl, this.dataset.sdsTitle);
  });
});

document.querySelectorAll('[data-sds-close]').forEach(el => {
  el.addEventListener('click', closeSds);
});

document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && sdsModal?.classList.contains('is-open')) {
    closeSds();
  }
});

// SDS page: filter the sheet list as the visitor types
const sdsFilter = document.querySelector('[data-sds-filter]');
if (sdsFilter) {
  const rows = [...document.querySelectorAll('[data-sds-row]')];
  const empty = document.querySelector('[data-sds-empty]');
  sdsFilter.addEventListener('input', () => {
    const q = sdsFilter.value.trim().toLowerCase();
    let shown = 0;
    rows.forEach(r => { r.hidden = !r.dataset.search.includes(q); if (!r.hidden) shown++; });
    if (empty) empty.hidden = shown > 0;
  });
}

  // ============================================
  // SCROLL REVEAL (sections fade up as they enter)
  // JS adds the hiding class itself, so no-JS users never see hidden content.
  // ============================================
  (function () {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = document.querySelectorAll('.ccs-section, .ccs-cta-trust');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      return; // leave content fully visible
    }

    // threshold 0: a section shows as soon as its top edge comes into view. A share of
    // the section's own height (it was 12%) can never be reached by a section taller than
    // the screen — a whole landing page of product rows, or any long section on a phone —
    // and that section then stayed invisible for good.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    var firstScreen = window.innerHeight;
    targets.forEach(function (el) {
      // Whatever starts on the first screen is simply there: a page must never look
      // empty while it waits for a scroll. Only sections further down fade in.
      if (el.getBoundingClientRect().top < firstScreen) return;
      el.classList.add('ccs-reveal');
      observer.observe(el);
    });
  })();

  // ============================================
  // MEGA-MENU PROMO SLIDESHOW (auto-rotate every 5s)
  // ============================================
  document.querySelectorAll('.ccs-mega-feature__slides').forEach(function (group) {
    var slides = group.querySelectorAll('.ccs-mega-feature__slide');
    if (slides.length <= 1) return;
    var index = 0;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 5000);
  });

  // ============================================
  // COLLECTION CATEGORY NAV — mobile toggle
  // ============================================
  document.querySelectorAll('[data-catnav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-catnav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ============================================
  // WISHLIST (custom, backend via App Proxy)
  // ============================================
  (function () {
    var API = '/apps/ccs/wishlist';
    var savedSet = null;

    function money(cents) {
      return ((parseInt(cents, 10) || 0) / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }
    function heartSvg() {
      return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    }
    // Same line-style cart icon used in the header.
    function cartSvg() {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    }
    function checkSvg() {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    }
    function setLabel(btn, on) {
      var label = btn.querySelector('.ccs-wish-btn__label');
      if (label) label.textContent = on ? 'Saved to Wishlist' : 'Save to Wishlist';
    }
    function markHearts() {
      if (!savedSet) return;
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var on = savedSet.has(btn.getAttribute('data-product-handle'));
        btn.classList.toggle('is-active', on);
        setLabel(btn, on);
      });
    }
    function updateBadge() {
      var n = savedSet ? savedSet.size : 0;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
      // Plain count (no hide) — e.g. the "Saved items" stat on the account dashboard.
      document.querySelectorAll('[data-wishlist-count-text]').forEach(function (el) { el.textContent = n; });
    }
    function loadSaved() {
      return fetch(API + '/list', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('list ' + r.status); return r.json(); })
        .then(function (d) { savedSet = new Set((d && d.handles) || []); updateBadge(); return savedSet; })
        .catch(function () {
          // Never wipe already-known hearts on a transient failure — keep prior state.
          if (!savedSet) savedSet = new Set();
          updateBadge();
          return savedSet;
        });
    }

    var page = document.querySelector('[data-wishlist-page]');

    function refreshEmpty() {
      var grid = page && page.querySelector('[data-wishlist-grid]');
      var empty = document.querySelector('[data-wishlist-empty]');
      if (grid && grid.children.length === 0) { grid.hidden = true; if (empty) empty.hidden = false; }
    }

    // Toggle (delegated so it also covers dynamically-rendered cards)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      if (!btn.getAttribute('data-logged-in')) { window.location.href = '/account/login'; return; }
      var handle = btn.getAttribute('data-product-handle');
      var willAdd = !btn.classList.contains('is-active');
      btn.classList.toggle('is-active', willAdd); setLabel(btn, willAdd);
      if (savedSet) { willAdd ? savedSet.add(handle) : savedSet.delete(handle); }
      updateBadge();
      // GET (not POST): Shopify's App Proxy doesn't reliably forward browser
      // POSTs from a logged-in session — they return the store HTML page and
      // never reach the app. GET proxies through fine and is signature-protected.
      fetch(API + '/toggle?product=' + encodeURIComponent(handle), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && typeof d.inWishlist === 'boolean') {
            btn.classList.toggle('is-active', d.inWishlist); setLabel(btn, d.inWishlist);
            if (savedSet) { d.inWishlist ? savedSet.add(handle) : savedSet.delete(handle); }
            updateBadge();
            if (!d.inWishlist) {
              var card = btn.closest('[data-wishlist-card]');
              if (card) { card.remove(); refreshEmpty(); }
            }
          }
        })
        .catch(function () {
          btn.classList.toggle('is-active', !willAdd); setLabel(btn, !willAdd);
          if (savedSet) { willAdd ? savedSet.delete(handle) : savedSet.add(handle); }
          updateBadge();
        });
    });

    // Add to Cart from the wishlist — adds the item to the cart but KEEPS it in
    // the wishlist (it's a saved list customers can order from repeatedly).
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest ? e.target.closest('[data-wishlist-add]') : null;
      if (!addBtn) return;
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid || addBtn.disabled) return;
      var orig = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = '<span class="ccs-btn-spinner" aria-hidden="true"></span><span>Adding…</span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () {
          // Refresh the header cart badge; the item stays in the wishlist.
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.ccs-cart-link__count').forEach(function (b) { b.textContent = cart.item_count; });
          }).catch(function () {});
          addBtn.innerHTML = '<span>Added</span>' + checkSvg();
          addBtn.style.background = '#22c55e';
          setTimeout(function () { addBtn.innerHTML = orig; addBtn.style.background = ''; addBtn.disabled = false; }, 1600);
        })
        .catch(function () {
          addBtn.innerHTML = '<span>Try again</span>';
          setTimeout(function () { addBtn.innerHTML = orig; addBtn.disabled = false; }, 1600);
        });
    });

    function cardHTML(p) {
      var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '';
      // Pick the first purchasable variant so "Add to Cart" works from the wishlist.
      var variants = p.variants || [];
      var v = null, i;
      for (i = 0; i < variants.length; i++) { if (variants[i].available) { v = variants[i]; break; } }
      var addBtn = v
        ? '<button type="button" class="ccs-add-btn ccs-add-btn--cart" data-wishlist-add data-variant-id="' + v.id + '"><span>Add to Cart</span>' + cartSvg() + '</button>'
        : '<button type="button" class="ccs-add-btn ccs-add-btn--cart" disabled><span>Sold Out</span></button>';
      // B2B stock badge for the display variant (first purchasable, else first).
      var stockHtml = '';
      var dv = v || variants[0];
      if (window.CCSStock && p._stock && dv) {
        var sd = p._stock[dv.id] || p._stock[String(dv.id)];
        if (sd) stockHtml = '<div class="ccs-wishlist-card__stock">' + window.CCSStock.html(sd.q, !!sd.t, !!sd.c) + '</div>';
      }
      return '<div class="ccs-product-card" data-wishlist-card>' +
        '<button type="button" class="ccs-product-card__action-btn ccs-wish-btn is-active" data-wishlist-toggle data-logged-in="true" data-product-handle="' + p.handle + '" aria-label="Remove from wishlist" title="Remove from wishlist">' + heartSvg() + '</button>' +
        '<a href="' + p.url + '" class="ccs-product-card__img">' + img + '</a>' +
        '<div class="ccs-product-card__body">' +
        '<h4 class="ccs-product-card__title"><a href="' + p.url + '">' + (p.title || '') + '</a></h4>' +
        stockHtml +
        '<div class="ccs-product-card__footer"><div class="ccs-price">' + money(p.price) + '</div>' +
        addBtn + '</div>' +
        '</div></div>';
    }

    if (page) {
      var grid = page.querySelector('[data-wishlist-grid]');
      var loading = page.querySelector('[data-wishlist-loading]');
      loadSaved().then(function (set) {
        var handles = Array.from(set);
        if (!handles.length) { if (loading) loading.remove(); refreshEmpty(); return; }
        var wantStock = window.CCSStock && window.CCSStock.enabled();
        Promise.all(handles.map(function (h) {
          var pJson = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          var pStock = wantStock
            ? fetch('/products/' + h + '?view=stock').then(function (r) { return r.ok ? r.text() : null; })
                .then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } }).catch(function () { return null; })
            : Promise.resolve(null);
          return Promise.all([pJson, pStock]).then(function (arr) {
            if (!arr[0]) return null;
            arr[0]._stock = arr[1] || null;
            return arr[0];
          });
        })).then(function (products) {
          if (loading) loading.remove();
          var html = products.filter(Boolean).map(cardHTML).join('');
          if (html) { grid.innerHTML = html; grid.hidden = false; } else { refreshEmpty(); }
        });
      });
    } else if (document.querySelector('[data-wishlist-toggle][data-logged-in], .ccs-header__wishlist-btn[data-logged-in]')) {
      // Logged-in on any page: sync saved set to mark hearts + populate the header badge
      loadSaved().then(markHearts);
    }
  })();

  // ============================================
  // PRODUCT REVIEWS (custom, backend via App Proxy)
  // ============================================
  (function () {
    var root = document.querySelector('[data-reviews]');
    if (!root) return;
    var api = root.getAttribute('data-review-api');
    var handle = root.getAttribute('data-product-handle');
    var listEl = root.querySelector('[data-reviews-list]');
    var summaryEl = root.querySelector('[data-reviews-summary]');

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function starsHTML(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        out += '<span class="ccs-rstar' + (i <= n ? ' is-on' : '') +
          '"><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>';
      }
      return out;
    }

    function render(data) {
      var reviews = (data && data.reviews) || [];
      var count = (data && data.count != null) ? data.count : reviews.length;
      var avg = (data && data.average != null) ? data.average : 0;

      if (count > 0 && summaryEl) {
        summaryEl.hidden = false;
        root.querySelector('[data-reviews-avg]').textContent = Number(avg).toFixed(1);
        root.querySelector('[data-reviews-avgstars]').innerHTML = starsHTML(Math.round(avg));
        root.querySelector('[data-reviews-count]').textContent =
          'Based on ' + count + ' review' + (count === 1 ? '' : 's');
      }

      if (!reviews.length) {
        listEl.innerHTML = '<div class="ccs-reviews__empty"><p>No reviews yet. Be the first to review this product.</p></div>';
        return;
      }
      listEl.innerHTML = reviews.map(function (r) {
        var initial = (r.name || 'C').charAt(0).toUpperCase();
        var date = r.date ? '<div class="ccs-review-item__date">' + esc(r.date) + '</div>' : '';
        return '<div class="ccs-review-item">' +
          '<div class="ccs-review-item__head">' +
          '<span class="ccs-review-item__avatar">' + esc(initial) + '</span>' +
          '<div><div class="ccs-review-item__name">' + esc(r.name || 'Verified Customer') + '</div>' + date + '</div>' +
          '<span class="ccs-review-item__stars">' + starsHTML(r.rating || 0) + '</span>' +
          '</div>' +
          (r.text ? '<p class="ccs-review-item__text">' + esc(r.text) + '</p>' : '') +
          '</div>';
      }).join('');
    }

    // Load reviews
    fetch(api + '/list?product=' + encodeURIComponent(handle), { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(render)
      .catch(function () {
        listEl.innerHTML = '<div class="ccs-reviews__empty"><p>Reviews are unavailable right now. Please check back soon.</p></div>';
      });

    // Star picker
    var ratingInput = root.querySelector('[data-review-rating]');
    var starWrap = root.querySelector('[data-review-starpick]');
    if (starWrap) {
      var stars = starWrap.querySelectorAll('[data-star]');
      function paint(n) { stars.forEach(function (s, i) { s.classList.toggle('is-on', i < n); }); }
      stars.forEach(function (s, i) {
        s.addEventListener('mouseenter', function () { paint(i + 1); });
        s.addEventListener('click', function () {
          ratingInput.value = s.getAttribute('data-star');
          paint(i + 1);
          starWrap.setAttribute('data-picked', s.getAttribute('data-star'));
        });
      });
      starWrap.addEventListener('mouseleave', function () { paint(parseInt(ratingInput.value, 10) || 5); });
    }

    // Submit
    var form = root.querySelector('[data-review-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-review-submit]');
        var msg = form.querySelector('[data-review-msg]');
        var payload = {
          product: form.product.value,
          rating: parseInt(form.rating.value, 10),
          text: form.text.value.trim()
        };
        if (!payload.text) return;
        btn.disabled = true; btn.textContent = 'Submitting…';
        fetch(api + '/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json().catch(function () { return { ok: res.ok }; }); })
          .then(function (data) {
            if (data && data.ok) {
              form.innerHTML = '<p class="ccs-review-form__thanks">Thank you! Your review has been received' +
                (data.pending ? ' and will appear once approved.' : '.') + '</p>';
            } else {
              msg.hidden = false;
              msg.textContent = (data && data.error) || 'Sorry, we couldn’t submit your review. Only verified buyers of this product can review it.';
              btn.disabled = false; btn.textContent = 'Submit Review';
            }
          })
          .catch(function () {
            msg.hidden = false;
            msg.textContent = 'Something went wrong. Please try again.';
            btn.disabled = false; btn.textContent = 'Submit Review';
          });
      });
    }
  })();

  // ============================================
  // REVIEW WIDGET (rate us -> Google review / private feedback)
  // ============================================
  (function () {
    var modal = document.querySelector('[data-review-modal]');
    if (!modal) return;
    var fab = document.querySelector('[data-review-open]');
    var stars = modal.querySelectorAll('[data-review-stars] .ccs-review__star');
    var steps = modal.querySelectorAll('[data-review-step]');
    var starWrap = modal.querySelector('[data-review-stars]');

    function showStep(name) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-review-step') !== name; });
    }
    function paintStars(n) {
      stars.forEach(function (star, i) { star.classList.toggle('is-lit', i < n); });
    }
    function openModal() {
      showStep('rate');
      paintStars(0);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ccs-review-open');
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ccs-review-open');
    }

    if (fab) fab.addEventListener('click', openModal);
    modal.querySelectorAll('[data-review-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    stars.forEach(function (star, i) {
      star.addEventListener('mouseenter', function () { paintStars(i + 1); });
      star.addEventListener('focus', function () { paintStars(i + 1); });
      star.addEventListener('click', function () {
        var rating = parseInt(star.getAttribute('data-star'), 10);
        paintStars(rating);
        setTimeout(function () { showStep(rating >= 4 ? 'happy' : 'feedback'); }, 250);
      });
    });
    if (starWrap) starWrap.addEventListener('mouseleave', function () { paintStars(0); });

    // Auto-open once per visitor, 25s after landing. Delete this block to disable.
    try {
      if (!localStorage.getItem('ccs_review_prompted')) {
        setTimeout(function () {
          if (!modal.classList.contains('is-open')) openModal();
          localStorage.setItem('ccs_review_prompted', '1');
        }, 25000);
      }
    } catch (e) {}
  })();

  // ============================================
  // MY ACCOUNT DASHBOARD — reorder, buy-again, profile
  // ============================================
  (function () {
    if (!document.querySelector('.ccs-account')) return;

    function spinner(txt) { return '<span class="ccs-btn-spinner" aria-hidden="true"></span><span>' + (txt || '') + '</span>'; }
    function parseItems(str) {
      return (str || '').split(';').map(function (p) {
        var t = p.split(':'); return t[0] ? { id: parseInt(t[0], 10), quantity: parseInt(t[1], 10) || 1 } : null;
      }).filter(Boolean);
    }
    function refreshCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.ccs-cart-link__count').forEach(function (b) { b.textContent = cart.item_count; });
      }).catch(function () {});
    }
    // Add items one at a time so a discontinued item doesn't fail the whole order.
    function addItemsSequential(items) {
      var added = 0;
      return items.reduce(function (chain, it) {
        return chain.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.id, quantity: it.quantity }) })
            .then(function (r) { if (r.ok) added++; }).catch(function () {});
        });
      }, Promise.resolve()).then(function () { return added; });
    }

    // Reorder a whole past order / "reorder last order" nudge
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-reorder]') : null;
      if (!btn || btn.disabled) return;
      var items = parseItems(btn.getAttribute('data-reorder'));
      if (!items.length) return;
      var orig = btn.innerHTML;
      btn.disabled = true; btn.innerHTML = spinner('Adding…');
      addItemsSequential(items).then(function (added) {
        refreshCartCount();
        if (added > 0) { window.location.href = '/cart'; }
        else { btn.innerHTML = '<span>Unavailable</span>'; setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800); }
      });
    });

    // Buy-Again qty steppers
    document.addEventListener('click', function (e) {
      var minus = e.target.closest ? e.target.closest('[data-ba-minus]') : null;
      var plus = e.target.closest ? e.target.closest('[data-ba-plus]') : null;
      if (!minus && !plus) return;
      var card = (minus || plus).closest('[data-ba-card]');
      var input = card && card.querySelector('[data-ba-qty]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = plus ? v + 1 : Math.max(1, v - 1);
    });

    // Buy-Again add to cart (per-card quantity)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-buyagain-add]') : null;
      if (!btn || btn.disabled) return;
      var card = btn.closest('[data-ba-card]');
      var qtyInput = card && card.querySelector('[data-ba-qty]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      var orig = btn.innerHTML;
      btn.disabled = true; btn.innerHTML = spinner('Adding…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { btn.innerHTML = orig; btn.disabled = false; return; }
          refreshCartCount();
          btn.innerHTML = '<span>Added</span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
          btn.style.background = '#22c55e';
          setTimeout(function () { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 1600);
        })
        .catch(function () { btn.innerHTML = orig; btn.disabled = false; });
    });

    // Profile name update (GET via App Proxy — POST is dropped for logged-in sessions)
    var pform = document.querySelector('[data-profile-form]');
    if (pform) {
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        var first = (pform.querySelector('[data-profile-first]').value || '').trim();
        var last = (pform.querySelector('[data-profile-last]').value || '').trim();
        var saveBtn = pform.querySelector('[data-profile-save]');
        var msg = pform.querySelector('[data-profile-msg]');
        var orig = saveBtn.innerHTML;
        saveBtn.disabled = true; saveBtn.innerHTML = spinner('Saving…');
        if (msg) msg.hidden = true;
        fetch('/apps/ccs/account/update-name?first=' + encodeURIComponent(first) + '&last=' + encodeURIComponent(last), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            saveBtn.innerHTML = orig; saveBtn.disabled = false;
            if (!msg) return;
            msg.hidden = false;
            if (d && d.ok) {
              msg.textContent = 'Saved'; msg.className = 'ccs-profile-form__msg is-ok';
              var greet = document.querySelector('[data-account-greeting]');
              if (greet && d.firstName) greet.textContent = 'Welcome back, ' + d.firstName;
            } else {
              msg.textContent = (d && d.error) || 'Could not save'; msg.className = 'ccs-profile-form__msg is-err';
            }
          })
          .catch(function () {
            saveBtn.innerHTML = orig; saveBtn.disabled = false;
            if (msg) { msg.hidden = false; msg.textContent = 'Could not save'; msg.className = 'ccs-profile-form__msg is-err'; }
          });
      });
    }

    // Trade-account application (account page). GET via App Proxy, like the name update.
    // On success the backend tags the customer, so a reload shows "Application received".
    var tform = document.querySelector('[data-trade-form]');
    if (tform) {
      tform.addEventListener('submit', function (e) {
        e.preventDefault();
        var sendBtn = tform.querySelector('[type="submit"]');
        var tmsg = tform.querySelector('[data-trade-msg]');
        var orig = sendBtn.innerHTML;
        var fail = function (text) {
          sendBtn.innerHTML = orig; sendBtn.disabled = false;
          tmsg.hidden = false; tmsg.textContent = text; tmsg.className = 'ccs-profile-form__msg is-err';
        };
        sendBtn.disabled = true; sendBtn.innerHTML = spinner('Sending…'); tmsg.hidden = true;
        fetch('/apps/ccs/trade-application?' + new URLSearchParams(new FormData(tform)).toString(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d && d.ok) location.reload(); else fail((d && d.error) || 'Could not send your application'); })
          .catch(function () { fail('Could not send your application. Please call us on 1300 312 276.'); });
      });
    }

    // Address book: show/hide add + edit forms
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-addr-toggle]') : null;
      if (!t) return;
      var el = document.getElementById(t.getAttribute('data-addr-toggle'));
      if (el) el.hidden = !el.hidden;
    });

    // Address delete (POST with method override — Shopify accepts within the session)
    document.addEventListener('click', function (e) {
      var del = e.target.closest ? e.target.closest('[data-addr-delete]') : null;
      if (!del) return;
      if (!window.confirm('Delete this address?')) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = del.getAttribute('data-url');
      form.style.display = 'none';
      var m = document.createElement('input');
      m.type = 'hidden'; m.name = '_method'; m.value = 'delete';
      form.appendChild(m);
      document.body.appendChild(form);
      form.submit();
    });
  })();

  // ============================================
  // B2B PRICING DISPLAY — retail vs. the logged-in customer's price
  // Exposes window.CCSB2B for the PDP / quick-view to reuse.
  // ============================================
  window.CCSB2B = (function () {
    var loggedIn = !!document.querySelector('.ccs-header__wishlist-btn[data-logged-in]');
    var prices = null;

    function fmt(cents) { return ((parseInt(cents, 10) || 0) / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }); }
    // Net price (in cents) for a SKU, or null if not priced.
    function net(sku) {
      if (!prices || !sku || !(sku in prices)) return null;
      var n = Math.round(parseFloat(prices[sku]) * 100);
      return n || null;
    }
    // "Your price" markup for a SKU vs a retail price (cents), or null if no saving.
    function priceHTML(sku, retailCents) {
      var n = net(sku);
      if (!n) return null;
      retailCents = parseInt(retailCents, 10) || 0;
      if (retailCents && n >= retailCents) return null;
      return '<span class="ccs-b2b-price">' +
        '<span class="ccs-b2b-price__yours">' + fmt(n) + '</span>' +
        (retailCents ? '<span class="ccs-b2b-price__retail">' + fmt(retailCents) + '</span>' : '') +
        '<span class="ccs-b2b-price__tag">Your price</span></span>';
    }
    // Premium "Trade Pricing" panel (retail / your price / savings + badge). Null if no saving.
    function panelHTML(sku, retailCents) {
      var n = net(sku);
      if (!n) return null;
      retailCents = parseInt(retailCents, 10) || 0;
      if (!retailCents || n >= retailCents) return null;
      var save = retailCents - n;
      var pct = Math.round(save / retailCents * 100);
      var award = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>';
      return '<div class="ccs-trade-panel">' +
        '<div class="ccs-trade-panel__head">' +
          '<span class="ccs-trade-panel__badge">' + award + 'Trade Pricing</span>' +
          (pct ? '<span class="ccs-trade-panel__pct">' + pct + '% off retail</span>' : '') +
        '</div>' +
        '<div class="ccs-trade-panel__grid">' +
          '<div class="ccs-trade-panel__cell"><span class="ccs-trade-panel__k">Retail</span><span class="ccs-trade-panel__retail">' + fmt(retailCents) + '</span></div>' +
          '<div class="ccs-trade-panel__cell ccs-trade-panel__cell--yours"><span class="ccs-trade-panel__k">Your price</span><span class="ccs-trade-panel__yours">' + fmt(n) + '</span></div>' +
        '</div>' +
        '<div class="ccs-trade-panel__save">You save ' + fmt(save) + '</div>' +
      '</div>';
    }
    // Annotate any static [data-b2b-sku] elements already in the DOM.
    function applyStatic(root) {
      (root || document).querySelectorAll('[data-b2b-sku]').forEach(function (el) {
        if (el.getAttribute('data-b2b-done')) return;
        var html = priceHTML(el.getAttribute('data-b2b-sku'), el.getAttribute('data-b2b-retail'));
        if (html) { el.setAttribute('data-b2b-done', '1'); el.innerHTML = html; }
      });
    }

    var ready;
    if (!loggedIn) {
      ready = Promise.resolve(false);
    } else {
      ready = fetch('/apps/ccs/b2b/prices', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.b2b && d.prices) {
            prices = d.prices;
            document.body.classList.add('ccs-is-b2b');
            applyStatic();
            return true;
          }
          return false;
        })
        .catch(function () { return false; });
    }

    // Let anything that ran BEFORE this module was defined (e.g. the PDP code
    // earlier in the file) react once pricing has settled.
    ready.then(function () { try { document.dispatchEvent(new CustomEvent('ccsb2b:ready')); } catch (e) {} });

    return { ready: ready, net: net, fmt: fmt, priceHTML: priceHTML, panelHTML: panelHTML, applyStatic: applyStatic, isB2B: function () { return !!prices; } };
  })();

});